import { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RadioSet from '../../../../../components/UI/MDC/Radio/RadioSet/RadioSet';
import Radio from '../../../../../components/UI/MDC/Radio/Radio';
import StyleAuxiliary from '../../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import DeleteModal from '../../../../../components/UI/Modal/DeleteModal';
import classnames from 'classnames';
import * as actions from '../../../../../store/apps/actions';

import { CSS_CLASSES } from './_constants';
import classes from './AcceptDecline.module.scss';

const AcceptDecline = props => {
	const [isAccept, setAccept] = useState(null);
	const [sIsDialogOpen, setIsDialogOpen] = useState(false);
	const dispatch = useDispatch();
	const extrasBase =
		props.extras && props.extras.acceptdecline
			? props.extras.acceptdecline
			: null;
	const labelAccept =
		extrasBase && extrasBase.accept ? extrasBase.accept : null;
	const labelDecline =
		extrasBase && extrasBase.decline ? extrasBase.decline : null;
	const trackingNumber = useSelector(state => state.apps.trackingNumber);
	const tabIndex = useSelector(state => state.apps.activeIndex);
	const nameApp = useSelector(state => state.apps.allForms[tabIndex].name);
	const searchParams = new URLSearchParams(window.location.search || '');
	const isAnnualReviewActionFlow =
		searchParams.get('uarSource') === 'annualReview';

	let styleAccept = classnames({
		[`${classes[CSS_CLASSES.OPTION]}`]: true,
		'mdc-form-field': true,
		[`${classes[CSS_CLASSES.LABEL_ACCEPT]}`]: isAccept,
	});
	let styleDecline = classnames({
		[`${classes[CSS_CLASSES.OPTION]}`]: true,
		'mdc-form-field': true,
		[`${classes[CSS_CLASSES.LABEL_DECLINE]}`]:
			isAccept !== null && !isAccept ? true : false,
	});

	/**
	 * Event handler for 'Accept' option.
	 * Passes hardcoded 'Accepted' value to onChangeHandler.
	 */
	const onAcceptHandler = () => {
		onChangeHandler('Accepted');
		setAccept(true);
	};

	/**
	 * Base event handler to update component value.
	 * @param {*} value The value of this [AcceptDecline] component to pass to parent onChangeHandler.
	 */
	const onChangeHandler = value => {
		const event = {
			target: {
				checked: null,
				id: props.key,
				name: props.name,
				options: null,
				selectedIndex: null,
				value: value,
			},
		};
		props.onChange(event, false);
	};

	/**
	 * Event handler for 'Decline' option.
	 * Passes `null` value to parent onChangeHandler, resets state value.
	 */
	const onDeclineHandler = () => {
		onChangeHandler(null);
		setAccept(false);

		if (isAnnualReviewActionFlow) {
			onConfirmDeclineHandler();
		} else {
			setIsDialogOpen(true);
		}
	};

	/**
	 * Event handler for confirming DeleteModal instance.
	 * Dispatches action to remove current application. Action requires payload containing current application ID, tab index, request tracking number.
	 */
	const onConfirmDeclineHandler = () => {
		if (isAnnualReviewActionFlow) {
			dispatch(
				actions.removeAppSync({
					index: tabIndex,
				})
			);
		} else {
			dispatch(
				actions.removeApp({
					appId: props.appId,
					tabIndex: tabIndex,
					trackingNumber: trackingNumber,
				})
			);
		}
		setIsDialogOpen(false);
	};

	return (
		<Fragment>
			<StyleAuxiliary classes={classes[CSS_CLASSES.ROOT]}>
				<RadioSet isVert />
				<StyleAuxiliary classes={styleAccept}>
					<Radio
						checked={isAccept !== null && isAccept}
						label={labelAccept}
						name={props.name}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}__accept`}
						onChange={() => onAcceptHandler()}
					/>
				</StyleAuxiliary>
				<StyleAuxiliary classes={styleDecline}>
					<Radio
						checked={isAccept !== null && !isAccept}
						label={labelDecline}
						name={props.name}
						id={`app-${props.appId}__component-${parseInt(
							props.name
						)}__decline`}
						onChange={() => onDeclineHandler()}
					/>
				</StyleAuxiliary>
				<DeleteModal
					isOpen={sIsDialogOpen}
					name={nameApp}
					onAccept={() => onConfirmDeclineHandler()}
					onDismiss={() => setIsDialogOpen(false)}
					onClose={() => setIsDialogOpen(false)}
				/>
			</StyleAuxiliary>
		</Fragment>
	);
};

export default AcceptDecline;
